'use strict';
import Fetch from '../../../common/scripts/fetch';
import Utility from '../../../common/scripts/utility';
import Clustering from './modules/clustering';
import Tour from './modules/tour';


window.TWER.clusterHover = false;

window.TWER.allSources = [];

window.TWER.clusterSources = '';
window.TWER.declusterSources = '';

window.TWER.circleLayers = [];
window.TWER.clustersLayers = [];
window.TWER.tourNumbersLayers = [];

window.TWER.filteredFeatures = [];

class TrewelerCore {

  async loadImages(images) {
    try {
      for (let imageName in images) {
        console.log(imageName, images[imageName], );
        const res = await this.loadImage(images[imageName]);
        TWER.map.addImage(imageName, res);
      }
    } catch (error) {
      console.error('Error loading images:', error);
    }
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      TWER.map.loadImage(url, (error, res) => {
        if (error) {
          reject(error);
        } else {
          resolve(res);
        }
      });
    });
  }

  constructor() {

    TWER.map.on('load', async () => {

      const circlesResponse = await new Fetch({
        action: 'get_circles_features',
        map_id : TWER.currentMapPageId
      });

      console.log(circlesResponse);

      if(circlesResponse.success) {


        if(!Utility.isEmpty( circlesResponse.data.other.images )) {
          await this.loadImages(circlesResponse.data.other.images);
        }

        for (const [type, url] of Object.entries(circlesResponse.data.source)) {
          let options = {
            type: 'geojson',
            data: url,
          }
          const sourceName = `${type}-source`;
          const layerName = `${type}-layer`
          const layerImagesName = `${type}-images-layer`;

          switch (type) {
            case 'clustering' :
              if(TWER.allowCluster) {
                options = {
                  ...{
                    cluster: TWER.allowCluster,
                    clusterMaxZoom: TWER.data.clusterMaxZoom,
                    clusterRadius: 50,
                  }, ...options
                };
              }
              TWER.clusterSources = sourceName;
              break;
            case 'declustering' :
              TWER.declusterSources = sourceName;
              break;
          }


          TWER.map.addSource(sourceName, options);
          TWER.map.addLayer({
            id: layerName,
            type: 'circle',
            source: sourceName,
            paint: {
              'circle-color': ['get', 'circle-color'],
              'circle-radius': ['get', 'circle-radius'],
              'circle-stroke-color': ['get', 'circle-stroke-color'],
              'circle-stroke-width': ['get', 'circle-stroke-width']
            },
            'filter': ['==', ['get', 'type'], 'circle']
          });
          TWER.circleLayers.push(layerName);


          if(!Utility.isEmpty( circlesResponse.data.other.images )) {
            const layoutOptions = {
              'icon-image': ['get', 'icon-image'],
              'icon-anchor': ['get', 'icon-anchor'],
              'icon-allow-overlap': true
            };

            if(circlesResponse.data.other.has_custom_images_sizes) {
              layoutOptions['icon-size'] = ['get', 'icon-size'];
            }
            TWER.map.addLayer({
              id: layerImagesName,
              type: 'symbol',
              source: sourceName,
              layout: layoutOptions,
              'filter': ['==', ['get', 'type'], 'custom-performance']
            });

            TWER.circleLayers.push(layerImagesName);
          }



          const { pathname } = new URL(url);
          const pathParts = pathname.split('/');
          const filename = pathParts[pathParts.length - 1];

          TWER.allSources.push({
            type : type,
            name : sourceName,
            url : url,
            data : new Fetch({
              action: 'get_geojson_file',
              filename : filename
            }),
            layers : !Utility.isEmpty( circlesResponse.data.other.images ) ? [layerName, layerImagesName] : [ layerName ]
          })
        }


        if(TWER.allowCluster) {
          new Clustering();
        }

        if(TWER.allowTour) {
          this.tour = new Tour();
          this.tour.addTourCircleNumbers();
        }


        TWER.circleLayers.forEach(layer => {
          TWER.map.on('mouseenter', layer, (e) => {
            TWER.map.getCanvas().style.cursor = typeof e.features[0].properties['icon-cursor'] !== 'undefined' ? e.features[0].properties['icon-cursor'] : 'pointer';
          });

          TWER.map.on('mousemove', layer, (e) => {
            TWER.map.getCanvas().style.cursor = typeof e.features[0].properties['icon-cursor'] !== 'undefined' ? e.features[0].properties['icon-cursor'] : 'pointer';;
          });

          TWER.map.on('mouseleave', layer, (e) => {
            if(!window.TWER.clusterHover) {
              TWER.map.getCanvas().style.cursor = '';
            }
          });

          TWER.map.on('click', layer, (e) => {
            if(e.features[0].properties?.cluster) {

            } else {
              const {allowMarkerCenterOnClick} = e.features[0].properties;
              const {enable, openInNewWindow, url } = JSON.parse( e.features[0].properties.markerLink );

              if(enable) {
                let target = openInNewWindow ? '_blank' : '_self';
                if(Utility.isIframeMap() && !openInNewWindow) {
                  target = '_parent';
                }

                window.open(url, target);
              }

              if(allowMarkerCenterOnClick) {
                TWER.map.jumpTo({
                  center: e.lngLat.wrap(),
                })
              }
            }

          })
        });

      }






      //for(let i = 0; i <= 50; i ++) {
      //  TWER.map.loadImage(
      //    'https://docs.mapbox.com/mapbox-gl-js/assets/cat.png',
      //    (error, image) => {
      //      if (error) throw error;
      //
      //      // Add the image to the map style.
      //      TWER.map.addImage('cat' + i, image);
      //      const longitude = -74.0021668856044 + (Math.random() - 0.5) * 0.027 * 2;
      //      const latitude = 40.7543209965726 + (Math.random() - 0.5) * 0.027 * 2;
      //      // Add a data source containing one point feature.
      //      TWER.map.addSource('point' + i, {
      //        'type': 'geojson',
      //        'data': {
      //          'type': 'FeatureCollection',
      //          'features': [
      //            {
      //              'type': 'Feature',
      //              'geometry': {
      //                'type': 'Point',
      //                'coordinates': [longitude, latitude]
      //              }
      //            }
      //          ]
      //        }
      //      });
      //
      //      // Add a layer to use the image to represent the data.
      //      TWER.map.addLayer({
      //        'id': 'points' + i,
      //        'type': 'symbol',
      //        'source': 'point' + i, // reference the data source
      //        'layout': {
      //          'icon-image': 'cat' + i, // reference the image
      //          'icon-size': 0.25
      //        }
      //      });
      //    }
      //  );
      //}


    });

  }
}

window.addEventListener('load', () => {
  new TrewelerCore();
});
